import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './styles.css';

InformationOrganize.propTypes = {
  infoOrganize: PropTypes.object.isRequired,
};

function InformationOrganize({ infoOrganize }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const videoRefs = useRef([]);

  // Lưu đường dẫn video vào một mảng (tránh require() trong JSX)
  const videoPaths = [require(`../../../../imgs/LandingPage/page2/${infoOrganize.id}/video2.mp4`)];

  // Quản lý video chạy/dừng theo slide
  useEffect(() => {
    videoRefs.current.forEach((video, index) => {
      if (video) {
        if (index === currentSlide) {
          video.muted = true;
          video.play().catch((error) => console.error('Play error:', error));
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  }, [currentSlide]);

  return (
    <div className="slider-container">
      <Carousel
        showArrows={true}
        showThumbs={false}
        showIndicators={false}
        showStatus={false}
        infiniteLoop={true}
        dynamicHeight={true}
        onChange={(index) => setCurrentSlide(index)}
      >
        {videoPaths.map((videoSrc, index) => (
          <div className="slide-item" key={index}>
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              controls
              muted
              playsInline
              loop
              preload="none" // 🔥 Ngăn video tải trước khi cần thiết
            >
              <source src={videoSrc} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}
      </Carousel>

      <div className="info-organize">
        <p>{infoOrganize.description}</p>
      </div>
    </div>
  );
}

export default InformationOrganize;
